import { jsx as _jsx } from "react/jsx-runtime";
import { List, Skeleton } from "antd";
import { useMemo } from "react";
const ScannerLoadingSkeleton = ({ count })=>{
    const dataSource = useMemo(()=>{
        const d = [];
        for(let key = 0; key < count; key++){
            d.push({
                key
            });
        }
        return d;
    }, [
        count
    ]);
    return /*#__PURE__*/ _jsx(List, {
        dataSource: dataSource,
        renderItem: ()=>/*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    loading: true,
                    active: true,
                    avatar: false,
                    paragraph: {
                        rows: 1
                    }
                })
            })
    });
};
export { ScannerLoadingSkeleton };
